import store from '@state/store'

export default [
  {
    path: '/',
    name: 'dashboard',
    component: () => lazyLoadView(import('@views/dashboard/dashboard')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => lazyLoadView(import('@views/register')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () => lazyLoadView(import('@views/forgetPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'home' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/company/create',
    name: 'createUser',
    component: () => lazyLoadView(import('@views/company/create')),
    meta: {
      authRequired: true,
    }
  },
  {
    path: '/company/corporates',
    name: 'Companies',
    component: () => lazyLoadView(import('@views/company/corporates')),
    meta: {
      authRequired: true,
    }
  },
  {
    path: '/company/api-partners',
    name: 'API-Partners',
    component: () => lazyLoadView(import('@views/company/api-partners')),
    meta: {
      authRequired: true,
    }
  },
  {
    path: '/company/company-details/:id',
    name: 'Company Details',
    component: () => lazyLoadView(import('@views/company/company-details')),
    meta: {
      authRequired: true,
    }
  },
  {
    path: '/company/assign-product/:company/:id',
    name: 'Assign Product',
    component: () => lazyLoadView(import('@views/company/assign-product')),
    meta: {
      authRequired: true,
    }
  },
  {
    path: '/company/assign-discount/:company/:id',
    name: 'Assign Discount',
    component: () => lazyLoadView(import('@views/company/assign-discount')),
    meta: {
      authRequired: true,
    }
  },
  {
    path: '/orders/orders',
    name: 'All orders',
    component: () => lazyLoadView(import('@views/orders/orders')),
    meta: {
      authRequired: true,
    }
  },

  {
    path: '/orders/success-orders',
    name: 'Successful orders',
    component: () => lazyLoadView(import('@views/orders/success-orders')),
    meta: {
      authRequired: true,
    }
  },

  {
    path: '/orders/pending-orders',
    name: 'Pending orders',
    component: () => lazyLoadView(import('@views/orders/pending-orders')),
    meta: {
      authRequired: true,
    }
  },

  {
    path: '/orders/failed-orders',
    name: 'Failed orders',
    component: () => lazyLoadView(import('@views/orders/failed-orders')),
    meta: {
      authRequired: true,
    }
  },

  {
    path: '/fund-request/:status',
    name: 'Fund requests',
    component: () => lazyLoadView(import('@views/fund-request/fund-requests')),
    meta: {
      authRequired: true,
    }
  },

  {
    path: '/reports/ledger',
    name: 'Ledger',
    component: () => lazyLoadView(import('@views/reports/ledger')),
    meta: {
      authRequired: true,
    }
  },

  {
    path: '/reports/api-reports',
    name: 'API Reports',
    component: () => lazyLoadView(import('@views/reports/api-report')),
    meta: {
      authRequired: true,
    }
  },

  {
    path: '/reports/order-reports',
    name: 'Ledger',
    component: () => lazyLoadView(import('@views/reports/order-report')),
    meta: {
      authRequired: true,
    }
  },

  {
    path: '/e-money/create',
    name: 'E-Money Create',
    component: () => lazyLoadView(import('@views/e-money/e-money-create')),
    meta: {
      authRequired: true,
    }
  },

  {
    path: '/e-money/list',
    name: 'E-Money History',
    component: () => lazyLoadView(import('@views/e-money/e-money-history')),
    meta: {
      authRequired: true,
    }
  },

  {
    path: '/product/list',
    name: 'Product',
    component: () => lazyLoadView(import('@views/product/product-list')),
    meta: {
      authRequired: true,
    }
  },

  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },

]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//

function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 200,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
